if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    #copyInputSelector = this.dataset.copyInputSelector;

    constructor() {
      super();
      this.copyButton = this.querySelector('.copy-share');
      this.copyInput = this.querySelector(this.#copyInputSelector);
    }

    connectedCallback() {
      if (this.copyButton) {
        window.theme.a11y.accessibilityClick(this.copyButton, (event) => this.handleCopyClick(event));
      }
    }

    handleCopyClick(event) {
      if (this.copyInput) {
        event.preventDefault();
        const phAnchorData = document.querySelector('.ph a')?.href.split('&id=');
        let phUrlCode = '';
        if (phAnchorData && phAnchorData[0] !== 'javascript:;') {
          phUrlCode = '?phId=' + phAnchorData[1];
        }
        navigator.clipboard.writeText(this.copyInput.value + phUrlCode).then(() => {
          const message = this.copyButton.dataset.message;
          Swal.fire({
            type: 'success',
            html: message,
            showConfirmButton: true,
            timer: 3000,
            buttonsStyling: false,
            customClass: {
              confirmButton: 'theme-btn theme-btn--gray-darker',
            },
          });
        });
      }
    }
  }

  customElements.define('social-share', SocialShare);
}
